import { render, staticRenderFns } from "./EndDispatchIcon.vue?vue&type=template&id=47b4845e"
import script from "./EndDispatchIcon.vue?vue&type=script&lang=js"
export * from "./EndDispatchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports